import React from 'react';

const UserAvatar = ({ user, size = 'medium' }) => {
  // Get initials from name
  const getInitials = (name) => {
    if (!name) return '?';
    const names = name.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  // Size classes
  const sizeClasses = {
    small: 'h-9 w-9 text-sm',
    medium: 'h-10 w-10 text-base',
    large: 'h-24 w-24 text-3xl'
  };

  const displayName = user?.full_name || user?.username || 'Unknown';
  const initials = getInitials(displayName);

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0`}
      title={displayName}
    >
      <span className="text-white font-bold">
        {initials}
      </span>
    </div>
  );
};

export default UserAvatar;
